import { render, staticRenderFns } from "./ProjectEditGeneral.vue?vue&type=template&id=1e42720b"
import script from "./ProjectEditGeneral.vue?vue&type=script&lang=ts"
export * from "./ProjectEditGeneral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e42720b')) {
      api.createRecord('1e42720b', component.options)
    } else {
      api.reload('1e42720b', component.options)
    }
    module.hot.accept("./ProjectEditGeneral.vue?vue&type=template&id=1e42720b", function () {
      api.rerender('1e42720b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ProjectEditGeneral.vue"
export default component.exports